import React from 'react'
import { useTranslate } from 'react-admin'
import { Grid, Button, Typography, Stack } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { useLocation, Link } from 'react-router-dom'

export const CardChildEntities = (props) => {
  const translate = useTranslate()
  const location = useLocation()
  const urlArray = location.pathname.split('/')
  let module = null

  if (urlArray.length > 1) {
    if (!isNaN(urlArray[2])) {
      // Tiene ID
      module = urlArray[1]
    } else {
      if (urlArray[1].length === 0) {
        // esta enla RAIZ
      } else if (urlArray[1].length > 0) {
        // Tiene MODULE
        module = urlArray[1]
      }
    }
  }

  if (props?.recordContext === undefined) {
    return <div>Loading...</div>
  }

  return (
    <CardCommon title={translate('ra.entity.child_entities')} actions={null}>
      <Grid container spacing={3}>
        <Grid item md={12}>
          {props?.recordContext?.length >= 1 ? (
            props?.recordContext?.map((child, i) => (
              <Grid container spacing={3} key={i} paddingTop={i === 0 ? 0 : 3}>
                <Grid item md={8}>
                  <Typography variant='button'>{child.long_name}</Typography>
                </Grid>
                <Grid item md={4}>
                  <Stack direction='row' spacing={2}>
                    <Button
                      size='small'
                      component={Link}
                      variant='outlined'
                      to={`/${module}/${child.id}/show`}
                    >
                      {translate('ra.action.show')}
                    </Button>
                    <Button
                      size='small'
                      component={Link}
                      variant='outlined'
                      to={`/${module}/${child.id}/edit`}
                    >
                      {translate('ra.action.edit')}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid item>
              <Typography variant='button'>{translate('ra.message.has_no_children')}</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </CardCommon>
  )
}
